<script setup>
import {computed, onMounted, onUnmounted} from 'vue'
import {useComponentFieldsStore} from '@/stores/componentFields'
import ContentTypeFieldsList from './ContentTypeFieldsList'
import ContentTypeNewAttributeBtn from './ContentTypeNewAttributeBtn'
import ContentTypeFieldEditForm from './ContentTypeFieldEditForm'

const props = defineProps({
    modal: Object,
    options: Object,
})

const emit = defineEmits(['hide-modal'])

const componentFieldsStore = useComponentFieldsStore()

// --- Computed ---

const activeEditId = computed(() => componentFieldsStore.activeEditId)

// --- Lifecycle Hooks ---

onMounted(() => {
    // Set initial state
    componentFieldsStore.activeFieldsetId = 0

    // Initialize the fields for the specific componentId passed via options
    componentFieldsStore.init({
        componentId: props.options.componentId
    })
})

onUnmounted(() => {
    // Clean up the store state when the modal closes
    componentFieldsStore.$reset()
})
</script>

<template>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Fields</h4>
                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-4 col-md-4">
                        <ContentTypeFieldsList/>
                        <ContentTypeNewAttributeBtn/>
                    </div>

                    <div class="col-xs-8 col-md-8">
                        <ContentTypeFieldEditForm
                            v-if="activeEditId >= 0"
                            :modal="modal"
                        />
                    </div>
                </div>
            </div>

            <div class="modal-footer"></div>
        </div>
    </div>
</template>

<style scoped>
.ghost {
    background: #666;
    border-color: #666;
    color: #fff;
}
</style>